export default "__VITE_ASSET__WAa_4xrx__"